<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive">
                        <div class="row d-flex align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-title m-0">
                                    <i class="bx bx-book me-1 text-primary"></i>Course Tests
                                </h5>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3 ps-1">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="filter" ngbTooltip="Select Course Test."
                                        placement="top" container="body">
                                        <i class='bx bx-book-reader'></i>
                                    </span>
                                    <select id="filter" class="form-select border-start-0"
                                        [ngClass]="{'no-event': isLoading}"[(ngModel)]="courseId">
                                        <option *ngFor="let course of courses" [value]="course.id">{{
                                            getTruncatedName(course.name?? '', 25) }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-2 me-auto ps-1">
                                <div class="input-group">
                                    <button type="button" ngbTooltip="Fetch Records." placement="top" container="body"
                                        class=" btn btn-secondary btn-sm " style="font-size: 18px;" (click)="onCourseChange()">
                                        <i class="bx bx-search-alt-2 ri-lg align-middle seach-icon"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-auto ms-auto">
                                <button type="button" class="btn btn-secondary" (click)="upsertCourseTest()"
                                    [ngClass]="{'not-allowed':!privilege.canEdit}"
                                    [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): course.courseTest.edit' : ''">
                                    <i class="bx bx-plus"></i> Add Course Test
                                </button>
                            </div>
                        </div>
                        <table class="table" id="table">
                            <thead id="table-thead">
                                <tr class="bg-light">
                                    <th scope="col" width="70">#</th>
                                    <th scope="col" width="200">Name</th>
                                    <th scope="col" width="200">Code</th>
                                    <th scope="col" width="200">Title</th>
                                    <th scope="col" width="200">Start Date</th>
                                    <th scope="col" width="200">End Date</th>
                                    <th scope="col" width="200" class="text-center">Passing Score</th>
                                    <th scope="col" width="200">Approval Status</th>
                                    <th scope="col" width="160" class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="let courseTest of courseTests | search : 'question' : searchKeyword; let i = index">
                                    <td>{{ i + 1 }}.</td>
                                    <td>{{ courseTest.name }}</td>
                                    <td>{{ courseTest.code }}</td>
                                    <td>{{ courseTest.title }}</td>
                                    <td>{{ courseTest.startDate | date:'MMM dd, yyyy' }}</td>
                                    <td>{{ courseTest.endDate | date:'MMM dd, yyyy' }}</td>
                                    <td class="text-center">{{ courseTest.passingScore }}</td>
                                    <td class="text-center">
                                        <span class="badge rounded-pill" [ngClass]="{
                                            'bg-warning': courseTest.approvalStatus === 'DRAFT',
                                            'bg-danger': courseTest.approvalStatus === 'IN_REVIEW',
                                            'bg-success': courseTest.approvalStatus === 'REVIEWED',
                                            'bg-primary': courseTest.approvalStatus === 'RELEASED',
                                            'bg-info': !courseTest.approvalStatus
                                        }">
                                            {{ courseTest?.approvalStatus || 'DRAFT' }}
                                        </span>
                                    </td>
                                    <td class="actions">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" [id]="i"
                                                [checked]="courseTest.disabled"
                                                [ngClass]="{'no-event':courseTest?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                                                [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): course.courseTest.edit' :courseTest.disabled ? 'Mark ' + courseTest.name + ' as enabled.' : 'Mark ' + courseTest.name + ' as disabled.'"
                                                placement="top" container="body" [(ngModel)]="courseTest.disabled"
                                                (change)="toggleCourseTestStatus(courseTest)">
                                            <label class="form-check-label" [for]="i"></label>
                                        </div>
                                        <i class="bx bx-edit alert-primary"
                                            [ngClass]="{'no-event':courseTest?.isDeleteInProgress,'not-allowed':!privilege.canEdit}"
                                            [ngbTooltip]="!privilege.canEdit ? 'You need permissions for this action. Required permission(s): course.courseTest.edit' : 'Update Course Test'"
                                            (click)="upsertCourseTest(courseTest)"></i>
                                        <i *ngIf="!courseTest?.isDeleteInProgress" class="bx bx-trash alert-secondary"
                                            [ngClass]="{'not-allowed':!privilege.canDelete}"
                                            [ngbTooltip]="!privilege.canDelete ? 'You need permissions for this action. Required permission(s): course.courseTest.delete' : 'Delete Course Test'"
                                            (click)="deleteCourseTest(courseTest,i)"></i>
                                        <div *ngIf="courseTest?.isDeleteInProgress" role="status"
                                            class="spinner-border spinner-border-sm text-danger">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr class="no-data">
                                    <ng-container *ngIf="isLoading; else noDataTemplate">
                                        <td colspan="9">Fetching data, please wait...</td>
                                    </ng-container>
                                    <ng-template #noDataTemplate>
                                        <ng-container *ngIf="courseTests && courseTests.length < 1; else noSearchResults">
                                            <td colspan="9">No course tests were found.</td>
                                        </ng-container>
                                        <ng-template #noSearchResults>
                                            <td colspan="9"
                                                *ngIf="searchKeyword && (courseTests | search : 'name' : searchKeyword).length == 0">
                                                No course tests were found for the search results.
                                            </td>
                                        </ng-template>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>